import {
  fromJS
} from 'immutable';
import {
  handleActions
} from 'redux-actions';
import * as Types from '../../actions/types';

const INITIAL_STATE = fromJS({
  loading: false,
  token: null,
  user: null,
  error: null
});

const authenticationReducer = handleActions({
  [Types.AUTHENTICATION_ATTEMPT]: (state, action) => state.merge({ loading: true, error: null }),
  [Types.AUTHENTICATION_SUCCESS]: (state, action) => state.merge({
    loading: false,
    token: action.payload.token,
    user: action.payload.user
  }),
  [Types.AUTHENTICATION_FAILURE]: (state, action) => state.merge({ loading: false, error: action.payload.error }),
  [Types.AUTHENTICATION_LOGOUT]: (state, action) => INITIAL_STATE
}, INITIAL_STATE);


export default authenticationReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/authentication/index.js